import React from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function Image({ src, name, url, className, onClick }) {
    const ImagePlaceholder = ComponentRegistry.get("ImagePlaceholder");
    let image = <ImagePlaceholder />;

    if (typeof src !== "undefined" && src !== null) {
        image = <img src={src} alt={name} className="img-fluid" />;
    }

    if ((typeof url === "undefined" || url === null) &&
        (typeof onClick === "undefined" || onClick === null)) {
            return image;
    }

    return <a href={url} onClick={onClick} className={className}>{image}</a>;
}

Image.propTypes = {
    src: React.PropTypes.string,
    url: React.PropTypes.string,
    onClick: React.PropTypes.func,
    name: React.PropTypes.string,
    className: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Atoms/Image.jsx